import _ from 'lodash'
import { combineYear } from 'legacy/services/entry/years'

export function onlyUploadedFiles(files) {
  return _.every(_.reject(files, { progress: 'error' }), 'pk')
}

export function onlyUploadedAttachments(attachments) {
  return _.every(
    _.reject(attachments, { progress: 'error' }),
    ({ pk, progress }) => pk || progress === 100
  )
}

export function greaterOrEqualToyearFrom() {
  const yearFrom = combineYear(this.parent.yearFrom, this.parent.yearFromSign)
  const yearTo = combineYear(this.parent.yearTo, this.parent.yearToSign)

  if (!_.isNull(yearFrom) && !_.isNull(yearTo)) {
    return yearFrom <= yearTo
  }

  return true
}

export function topLevelTagRequired(tags) {
  return !!_.find(tags, { level: 1 })
}

export function twoTopLevelsTagRequired(tags) {
  return !!(_.find(tags, { level: 1 }) && _.find(tags, { level: 2 }))
}
